export default __webpack_public_path__ + "static/media/client-background-image.1a1b55ee.jpg";